import { createMuiTheme } from '@material-ui/core';
// import parser from 'ua-parser-js';
import mediaQuery from 'css-mediaquery';
import { isMobile } from 'react-device-detect';

const ssrMatchMedia = (query: string) => ({
  matches: mediaQuery.match(query, {
    // The estimated CSS width of the browser.
    width: isMobile ? '0px' : '1024px',
  }),
});

const theme = createMuiTheme({
  // props: {
  //   // Change the default options of useMediaQuery
  //   MuiUseMediaQuery: { ssrMatchMedia },
  // },
  typography: {
    fontFamily: ['Nunito', 'Roboto', 'sans-serif'].join(','),
    h1: {
      fontFamily: 'Roboto',
      fontSize: '96px',
      fontWeight: 500,
    },
    h2: {
      fontFamily: 'Roboto',
      fontSize: '60px',
      fontWeight: 500,
    },
    h3: {
      fontFamily: 'Roboto',
      fontSize: '48px',
      fontWeight: 700,
    },
    h4: {
      fontFamily: 'Roboto',
      fontSize: '34px',
      fontWeight: 700,
    },
    h5: {
      fontFamily: 'Roboto',
      fontSize: '24px',
      fontWeight: 700,
    },
    h6: {
      fontFamily: 'Roboto',
      fontSize: '20px',
      fontWeight: 700,
    },
    subtitle1: {
      fontFamily: 'Nunito',
      fontSize: '16px',
      fontWeight: 600,
    },
    subtitle2: {
      fontFamily: 'Nunito',
      fontSize: '14px',
      fontWeight: 700,
    },
    body1: {
      fontFamily: 'Nunito',
      fontSize: '16px',
      fontWeight: 400,
    },
    body2: {
      fontFamily: 'Nunito',
      fontSize: '14px',
      fontWeight: 400,
    },
    button: {
      textTransform: 'none',
      fontFamily: 'Nunito',
      fontSize: '14px',
      fontWeight: 600,
    },
    caption: {
      fontFamily: 'Nunito',
      fontSize: '12px',
      fontWeight: 400,
    },
    overline: {
      fontFamily: 'Nunito',
      fontSize: '12px',
      fontWeight: 700,
    },
  },
  palette: {
    primary: {
      light: '#7B73FF',
      main: '#6C63FF',
      dark: '#5F57E0',
      contrastText: '#FFFFFF',
    },
  },
});

export default theme;
